import { Link } from 'react-router-dom';
import { DEALERSHIP_PHONE_DISPLAY } from '../../constants/dealershipContact';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import '../AllCss/CookiesPolicy.css';

function CookiesPolicy() {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="cookies-policy-page">
        {/* Breadcrumb */}
        <section className="breadcrumb-section">
          <div className="breadcrumb-container">
            <ol className="breadcrumb">
              <li>
                <Link to="/" className="breadcrumb-link">Home Page</Link>
                <span className="breadcrumb-separator">/</span>
              </li>
              <li>
                <span className="breadcrumb-text">Legal</span>
                <span className="breadcrumb-separator">/</span>
              </li>
              <li className="breadcrumb-text">Cookies Policy</li>
            </ol>
          </div>
        </section>

        {/* Header */}
        <div className="header-section">
          <div className="header-container">
            <h1>Cookies Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>

        {/* Main Content with Sidebar */}
        <div className="content-wrapper">
          {/* Sidebar */}
          <aside className="sidebar">
            <nav className="sidebar-nav">
              <ul className="nav-list">
                <li><a href="#what-are-cookies" className="nav-link" onClick={(e) => handleNavClick(e, 'what-are-cookies')}>What are cookies</a></li>
                <li><a href="#types-of-cookies" className="nav-link" onClick={(e) => handleNavClick(e, 'types-of-cookies')}>Types of cookies we use</a></li>
                <li><a href="#purpose-of-cookies" className="nav-link" onClick={(e) => handleNavClick(e, 'purpose-of-cookies')}>Purpose of cookies</a></li>
                <li><a href="#third-party-cookies" className="nav-link" onClick={(e) => handleNavClick(e, 'third-party-cookies')}>Third-party cookies</a></li>
                <li><a href="#cookie-control" className="nav-link" onClick={(e) => handleNavClick(e, 'cookie-control')}>Cookie control and your choices</a></li>
                <li><a href="#similar-technologies" className="nav-link" onClick={(e) => handleNavClick(e, 'similar-technologies')}>Similar technologies</a></li>
                <li><a href="#updates" className="nav-link" onClick={(e) => handleNavClick(e, 'updates')}>Updates to this policy</a></li>
                <li><a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, 'contact')}>How to contact us</a></li>
              </ul>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="main-content">
            <p className="intro-text">
              Thank you for visiting the My Cars Lot LLC website (including its mobile device-ready version) or using the My Cars Lot LLC mobile app. 
              This Cookies Policy explains how My Cars Lot LLC ("we", "us", "our", or "the Company") uses cookies and similar tracking technologies 
              when you visit our website at www.mycarslot.com or use our mobile applications (collectively, our "Online Services"). This policy should 
              be read in conjunction with our Privacy Policy, which provides additional information about how we collect, use, and protect your personal information.
            </p>

            <section id="what-are-cookies" className="content-section">
              <h2>What are cookies</h2>
              <p>
                Cookies are small text files that are placed on your computer or mobile device when you visit a website or use a mobile application. 
                Cookies are widely used by website owners to make their websites work more efficiently, provide a better user experience, and provide 
                information to website owners.
              </p>
              <p>
                Cookies allow a website or mobile app to recognize your device and store some information about your preferences, past actions, or 
                browsing behavior. This enables websites and applications to provide you with a better, more personalized user experience and allows 
                website operators to analyze how their sites and apps are being used, identify areas for improvement, and deliver more relevant content and advertising.
              </p>
              <p>
                There are two main types of cookies:
              </p>
              <ul>
                <li><strong>Session Cookies:</strong> These are temporary cookies that are deleted when you close your browser or exit the application. 
                They help websites and apps remember information as you navigate between pages or screens during a single browser or app session. 
                Session cookies are essential for the proper functioning of many websites and applications.</li>
                <li><strong>Persistent Cookies:</strong> These remain on your device for a set period of time or until you delete them manually. 
                They help websites remember your preferences, settings, login information, and other details for future visits. Persistent cookies 
                enable features such as "remember me" functionality and personalized content delivery.</li>
              </ul>
              <p>
                Cookies may also be classified as "first-party" cookies (set by the website you are visiting) or "third-party" cookies (set by 
                domains other than the website you are visiting, such as advertisers or analytics providers).
              </p>
            </section>

            <section id="types-of-cookies" className="content-section">
              <h2>Types of cookies we use</h2>
              <p>
                We use several types of cookies on our Online Services, each serving different purposes. The cookies we use fall into the following categories:
              </p>

              <h3>Essential Cookies</h3>
              <p>
                These cookies are strictly necessary for the website and mobile applications to function properly and cannot be switched off in our systems. 
                They are usually set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, 
                logging in, or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not 
                function as a result.
              </p>
              <ul>
                <li><strong>Authentication Cookies:</strong> Enable you to log in and access secure areas of our website</li>
                <li><strong>Security Cookies:</strong> Help detect and prevent fraudulent activity and security threats</li>
                <li><strong>Session Management Cookies:</strong> Maintain your session while you navigate through our website</li>
                <li><strong>Load Balancing Cookies:</strong> Distribute website traffic across servers to ensure optimal performance</li>
                <li><strong>User Interface Cookies:</strong> Remember your interface preferences and settings</li>
              </ul>
              <p>
                <strong>Browser storage (localStorage and sessionStorage):</strong> We also store limited data in your browser, including
                authentication tokens, chat session identifiers, saved zip code, cookie consent choices, and analytics session IDs. These are
                not cookies but serve similar purposes. We use them to keep you signed in and remember preferences. For stronger account security,
                sign out on shared devices. HttpOnly server-side session cookies may be introduced in a future update to reduce exposure of auth tokens
                in browser storage.
              </p>

              <h3>Performance and Analytics Cookies</h3>
              <p>
                These cookies help us understand how visitors interact with our Online Services by collecting and reporting information anonymously. 
                This information helps us improve the way our website and mobile applications work, identify technical issues, and enhance user experience. 
                These cookies do not collect information that identifies you personally.
              </p>
              <ul>
                <li><strong>Google Analytics Cookies:</strong> Analyze website traffic, user behavior, page views, and navigation patterns</li>
                <li><strong>Page View Tracking:</strong> Record which pages you visit and how long you spend on each page</li>
                <li><strong>Click Tracking:</strong> Monitor user interactions, clicks, and engagement with website elements</li>
                <li><strong>Performance Monitoring:</strong> Track website speed, loading times, and technical performance metrics</li>
                <li><strong>Error Tracking:</strong> Identify and diagnose technical errors, bugs, and usability issues</li>
                <li><strong>A/B Testing Cookies:</strong> Enable us to test different versions of our website to improve functionality</li>
              </ul>

              <h3>Functionality Cookies</h3>
              <p>
                These cookies allow our Online Services to remember choices you make (such as your username, language preference, region, or dealership 
                location) and provide enhanced, personalized features. They may also be used to provide services you have requested, such as watching a 
                video or commenting on a blog. These cookies enable us to remember your preferences and tailor our services to provide you with features 
                and content that are more relevant to you.
              </p>
              <ul>
                <li><strong>User Preference Cookies:</strong> Remember your preferences, settings, and customization choices</li>
                <li><strong>Language and Location Settings:</strong> Store your preferred language and geographic location</li>
                <li><strong>Search History Cookies:</strong> Remember your recent searches and search preferences</li>
                <li><strong>Customized Content Delivery:</strong> Provide personalized content based on your preferences and browsing history</li>
                <li><strong>Feature Enhancement Cookies:</strong> Enable enhanced features such as saved vehicles, wishlist, and comparison tools</li>
              </ul>

              <h3>Targeting and Advertising Cookies</h3>
              <p>
                These cookies are used to deliver advertisements that are more relevant to you and your interests. They are also used to limit the number 
                of times you see an advertisement, measure the effectiveness of advertising campaigns, and understand user behavior across different websites 
                and devices. These cookies may track your browsing activity across different websites to build a profile of your interests.
              </p>
              <ul>
                <li><strong>Behavioral Advertising Cookies:</strong> Deliver targeted advertisements based on your browsing behavior and interests</li>
                <li><strong>Retargeting Cookies:</strong> Show you relevant advertisements for vehicles and services you have viewed on our website</li>
                <li><strong>Social Media Tracking Cookies:</strong> Enable social media platforms to track your activity and deliver relevant ads</li>
                <li><strong>Advertising Network Cookies:</strong> Used by advertising networks to serve personalized advertisements</li>
                <li><strong>Conversion Tracking Cookies:</strong> Measure the effectiveness of our advertising campaigns and marketing efforts</li>
              </ul>
            </section>

            <section id="purpose-of-cookies" className="content-section">
              <h2>Purpose of cookies</h2>
              <p>
                We use cookies for the following purposes:
              </p>
              <ul>
                <li><strong>Website and Application Functionality:</strong> To enable essential features and ensure our Online Services operate correctly, 
                securely, and efficiently. This includes maintaining user sessions, processing transactions, and enabling interactive features.</li>
                <li><strong>User Experience Enhancement:</strong> To remember your preferences, settings, and past interactions to provide you with a 
                personalized and seamless browsing experience. This includes remembering your preferred dealership location, saved searches, and display preferences.</li>
                <li><strong>Analytics and Performance:</strong> To analyze how visitors use our Online Services, identify popular content and features, 
                monitor technical performance, and identify areas for improvement. This helps us optimize our website and mobile applications.</li>
                <li><strong>Marketing and Advertising:</strong> To deliver relevant advertisements based on your interests and browsing behavior, measure 
                the effectiveness of our marketing campaigns, and limit the number of times you see the same advertisement.</li>
                <li><strong>Security and Fraud Prevention:</strong> To detect and prevent fraudulent activity, unauthorized access, security threats, and 
                abuse of our Online Services. This helps protect both you and our business.</li>
                <li><strong>Performance Optimization:</strong> To optimize website and application performance, reduce loading times, and ensure reliable 
                operation across different devices and network conditions.</li>
                <li><strong>Social Media Integration:</strong> To enable social media sharing features, allow you to interact with social media platforms 
                through our Online Services, and display social media content.</li>
                <li><strong>Customer Service:</strong> To remember information you provide during customer service interactions, enable chat functionality, 
                and improve our ability to assist you effectively.</li>
              </ul>
            </section>

            <section id="third-party-cookies" className="content-section">
              <h2>Third-party cookies</h2>
              <p>
                In addition to our own cookies, we may also use various third-party cookies to report usage statistics, deliver advertisements, provide 
                social media features, process payments, and provide other services. These third parties set their own cookies and may use similar tracking 
                technologies to collect information about your online activities across different websites and services.
              </p>
              <p>Third parties that may set cookies on our Online Services include:</p>
              <ul>
                <li><strong>Google Analytics:</strong> We use Google Analytics to analyze website traffic, user behavior, and website performance. Google 
                Analytics uses cookies and other tracking technologies to collect information about how visitors use our site. This information is used to 
                compile reports and help us improve our website. For more information about how Google uses data, please visit 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer"> Google's Privacy Policy</a> and 
                <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer"> How Google uses information from sites or apps that use its services</a>.</li>
                <li><strong>Google reCAPTCHA:</strong> We use Google reCAPTCHA to protect our website from spam and abuse. reCAPTCHA uses cookies and other 
                tracking technologies to analyze your behavior and determine whether you are a human user or a bot.</li>
                <li><strong>Advertising Networks and Partners:</strong> We work with advertising partners, ad networks, and ad technology providers who use 
                cookies to deliver targeted advertisements based on your browsing behavior and interests. These partners may include companies such as Google Ads, 
                Facebook, and other programmatic advertising platforms.</li>
                <li><strong>Social Media Platforms:</strong> Social media platforms such as Facebook, Twitter, LinkedIn, Instagram, and others may set cookies 
                when you interact with social media features on our website, such as sharing buttons, embedded content, or when you log in using social media credentials.</li>
                <li><strong>Payment Processors:</strong> Payment processing services such as credit card processors and payment gateways may use cookies to facilitate 
                secure transactions, verify your identity, and prevent fraud.</li>
                <li><strong>Customer Service Platforms:</strong> Customer service and chat platforms may use cookies to enable chat functionality and improve 
                customer service interactions.</li>
                <li><strong>Email Service Providers:</strong> Email marketing and service providers may use cookies and tracking pixels to track email open rates, 
                clicks, and engagement with email communications.</li>
              </ul>
              <p>
                <strong>Important:</strong> We do not control these third-party cookies, and their use is governed by the privacy policies of the respective 
                third parties. We encourage you to review the privacy policies of these third-party services to understand how they use cookies and other tracking 
                technologies. These third parties may collect information about your online activities over time and across different websites, applications, and devices.
              </p>
            </section>

            <section id="cookie-control" className="content-section">
              <h2>Cookie control and your choices</h2>
              <p>
                You have the right to decide whether to accept or reject cookies. Most web browsers and mobile devices allow you to control cookies through their 
                settings. However, please note that blocking or deleting cookies may impact your ability to use certain features of our Online Services.
              </p>

              <h3>Browser Settings</h3>
              <p>
                Most web browsers allow you to control cookies through their settings. You can typically configure your browser to:
              </p>
              <ul>
                <li>Block all cookies</li>
                <li>Block third-party cookies only</li>
                <li>Accept cookies only from specific websites</li>
                <li>Delete cookies when you close your browser</li>
                <li>Delete existing cookies at any time</li>
                <li>Notify you before a cookie is stored</li>
                <li>View and manage cookies stored on your device</li>
              </ul>
              <p>
                Instructions for managing cookies in popular web browsers:
              </p>
              <ul>
                <li><strong>Google Chrome:</strong> Settings → Privacy and security → Cookies and other site data. You can choose to block all cookies, block 
                third-party cookies, or allow all cookies. You can also view and delete cookies individually.</li>
                <li><strong>Mozilla Firefox:</strong> Options → Privacy & Security → Cookies and Site Data. You can set Firefox to block cookies from all sites, 
                block third-party cookies, or allow all cookies. You can also manage exceptions and view stored cookies.</li>
                <li><strong>Microsoft Edge:</strong> Settings → Privacy, search, and services → Cookies and site permissions → Cookies and site data. You can block 
                all cookies, block only third-party cookies, or allow all cookies.</li>
                <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data. You can block all cookies, block only third-party cookies, or allow 
                all cookies. Safari also offers Intelligent Tracking Prevention to limit cross-site tracking.</li>
                <li><strong>Opera:</strong> Settings → Privacy & security → Cookies. You can block third-party cookies or block all cookies.</li>
              </ul>

              <h3>Mobile Device Settings</h3>
              <p>
                Mobile devices also allow you to control cookies and similar technologies:
              </p>
              <ul>
                <li><strong>iOS (Safari):</strong> Settings → Safari → Block All Cookies or Prevent Cross-Site Tracking</li>
                <li><strong>Android (Chrome):</strong> Chrome menu → Settings → Site settings → Cookies. You can block cookies, allow cookies, or block third-party cookies</li>
              </ul>

              <h3>Opt-Out Links for Third-Party Cookies</h3>
              <p>
                You can opt out of certain third-party cookies and interest-based advertising through the following resources:
              </p>
              <ul>
                <li><strong>Google Analytics:</strong> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a></li>
                <li><strong>Network Advertising Initiative (NAI):</strong> <a href="http://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer">NAI Opt-Out Page</a></li>
                <li><strong>Digital Advertising Alliance (DAA):</strong> <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">DAA Consumer Choice Page</a></li>
                <li><strong>European Interactive Digital Advertising Alliance (EDAA):</strong> <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer">Your Online Choices</a></li>
                <li><strong>Google Ads Settings:</strong> <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer">Google Ad Personalization Settings</a></li>
              </ul>
              <p>
                <strong>Note:</strong> Opt-out choices may be browser-specific and device-specific. If you use multiple browsers or devices, you may need to opt out 
                on each one. Additionally, opting out does not mean you will no longer see advertisements; it means the advertisements you see may be less relevant 
                to your interests.
              </p>

              <h3>Impact of Disabling or Blocking Cookies</h3>
              <p>
                <strong>Important:</strong> If you choose to disable or block cookies, some features of our Online Services may not function properly or may be 
                unavailable. For example, you may not be able to:
              </p>
              <ul>
                <li>Access certain areas or features of our website or mobile applications</li>
                <li>Save your preferences, settings, and customization choices</li>
                <li>Use personalized features such as saved searches, wishlist, or vehicle comparisons</li>
                <li>Complete online transactions or checkout processes</li>
                <li>Access your account or saved information</li>
                <li>Receive personalized content and recommendations</li>
                <li>Use certain interactive features and functionalities</li>
              </ul>
              <p>
                We recommend that you leave essential cookies enabled, as they enable basic functionality and security features of our Online Services. 
                You can disable non-essential cookies while keeping essential cookies enabled.
              </p>

              <h3>Do Not Track Signals</h3>
              <p>
                Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit that you do not want to have your online activity tracked. 
                Currently, there is no industry standard for how to respond to DNT signals. As a result, we do not currently respond to DNT browser signals or mechanisms. 
                We will continue to monitor developments regarding DNT signals and may update our practices accordingly in the future.
              </p>
            </section>

            <section id="similar-technologies" className="content-section">
              <h2>Similar technologies</h2>
              <p>
                In addition to cookies, we may use other similar technologies to store information on your device or track your online activities, including:
              </p>
              <ul>
                <li><strong>Local Storage:</strong> Data stored locally in your browser that persists even after you close the browser. Local storage can store 
                larger amounts of data than cookies and is commonly used for storing user preferences, settings, and application data.</li>
                <li><strong>Session Storage:</strong> Data stored temporarily in your browser for the duration of your browser session. Session storage is similar 
                to local storage but is cleared when the browser session ends.</li>
                <li><strong>Web Beacons (Pixel Tags):</strong> Small invisible images or code snippets embedded in web pages or emails that help us track website 
                usage, email open rates, and user interactions. Web beacons can be used to determine if an email has been opened or if a web page has been viewed.</li>
                <li><strong>Flash Cookies (Local Shared Objects):</strong> Data stored using Adobe Flash technology. Flash cookies can store more data than regular 
                cookies and can persist across browser sessions. Most modern browsers have disabled Flash support, but some older websites may still use Flash cookies.</li>
                <li><strong>Device Fingerprinting:</strong> Techniques that collect information about your device's characteristics (such as screen resolution, 
                installed fonts, and browser plugins) to create a unique identifier for your device.</li>
                <li><strong>Mobile Device Identifiers:</strong> Unique identifiers associated with your mobile device, such as Advertising IDs (IDFA on iOS, 
                Android Advertising ID on Android) that are used for advertising and analytics purposes.</li>
                <li><strong>ETags (Entity Tags):</strong> HTTP headers used for web cache validation that can also function as tracking mechanisms.</li>
              </ul>
              <p>
                These technologies serve similar purposes to cookies and are subject to the same controls and preferences as cookies. You can typically control 
                these technologies through your browser or device settings in the same way you control cookies.
              </p>
            </section>

            <section id="updates" className="content-section">
              <h2>Updates to this policy</h2>
              <p>
                We may update this Cookies Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. 
                We will notify you of any material changes by posting the updated policy on our website and updating the "Last updated" date at the top of this page.
              </p>
              <p>
                We encourage you to review this Cookies Policy periodically to stay informed about how we use cookies and similar technologies. Your continued 
                use of our Online Services after any changes to this Cookies Policy constitutes your acceptance of the updated policy.
              </p>
              <p>
                If we make material changes to this Cookies Policy that significantly affect your rights or the way we use cookies, we will take reasonable steps 
                to notify you, such as posting a prominent notice on our website or sending you an email notification, where applicable.
              </p>
            </section>

            <section id="contact" className="content-section">
              <h2>How to contact us</h2>
              <p>
                If you have any questions about this Cookies Policy or our use of cookies and similar technologies, please contact us:
              </p>
              <address className="contact-address">
                <strong>My Cars Lot LLC</strong><br />
                Privacy Officer / Data Protection Officer<br />
                Legal Department<br />
                6314 Washington Ave<br />
                Ocean Springs, MS 39564<br />
                United States<br /><br />
                Email: <a href="mailto:privacy@mycarslotllc.com">privacy@mycarslotllc.com</a><br />
                Phone: {DEALERSHIP_PHONE_DISPLAY}<br />
                Website: <a href="/">www.mycarslot.com</a>
              </address>
            </section>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CookiesPolicy;

